module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('news-heading', {
    attrs: {
      "subtitle": true
    }
  }, [_vm._v("Latest News")]), _vm._v(" "), _c('news-internal-slide', {
    attrs: {
      "articles": _vm.internals
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [(_vm.recipe) ? _c('section', {
    staticClass: "combo combo--2 combo--third"
  }, [_c('a', {
    attrs: {
      "href": _vm.recipe.url
    }
  }, [_c('news-heading', {
    attrs: {
      "subtitle": true
    }
  }, [_vm._v("Recipe of the Week")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.recipe.image,
      "alt": _vm.recipe.image_alt
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "recipe-title",
    domProps: {
      "innerHTML": _vm._s(_vm.recipe.title)
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "combo combo--2 combo--third"
  }, [_c('a', {
    attrs: {
      "href": _vm.recipe.url
    }
  }, [_c('news-heading', {
    attrs: {
      "subtitle": true
    }
  }, [_vm._v("Latest video")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": ("https://www.youtube.com/embed/" + _vm.videoId),
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1)]), _vm._v(" "), (_vm.destination) ? _c('section', {
    staticClass: "combo combo--2 combo--third"
  }, [_c('a', {
    attrs: {
      "href": _vm.destination.url
    }
  }, [_c('news-heading', {
    attrs: {
      "subtitle": true
    }
  }, [_vm._v("Destination of the day")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.destination.image,
      "alt": _vm.destination.image_alt
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "recipe-title",
    domProps: {
      "innerHTML": _vm._s(_vm.destination.title)
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('news-heading', {
    attrs: {
      "subtitle": true
    }
  }, [_vm._v("Latest Features")]), _vm._v(" "), _c('features-slide', {
    attrs: {
      "features": _vm.features
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-container"
  }, [_c('section', {
    staticClass: "combo combo--1 combo--third"
  }, [_c('a', {
    attrs: {
      "href": "/history-of-palestine"
    }
  }, [_c('h2', [_vm._v("The History of Palestine")]), _vm._v(" "), _c('div', {
    staticClass: "parallax-image",
    staticStyle: {
      "background-image": "url(https://www.welcometopalestine.com/wp-content/uploads/2017/04/historyhome.jpg)"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Step through the window of time and explore the History of Palestine with our interactive timeline dating\n                    from 12500BC – 21st Century.")])])]), _vm._v(" "), _c('section', {
    staticClass: "combo combo--1 combo--third"
  }, [_c('a', {
    attrs: {
      "href": "/getting-in"
    }
  }, [_c('h2', [_vm._v("Getting In")]), _vm._v(" "), _c('div', {
    staticClass: "parallax-image parallax-image--inverted delay--1",
    staticStyle: {
      "background-image": "url(https://www.welcometopalestine.com/wp-content/uploads/2017/02/Getting-in-to-Pal-600x300.jpg)"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Whether you are travelling to The West Bank or Gaza – follow our extensive guide on the easiest methods\n                    of travel to Palestine.")])])]), _vm._v(" "), _c('section', {
    staticClass: "combo combo--1 combo--third"
  }, [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_c('h2', [_vm._v("About Us")]), _vm._v(" "), _c('div', {
    staticClass: "parallax-image delay--2",
    staticStyle: {
      "background-image": "url(https://www.welcometopalestine.com/wp-content/uploads/2017/03/AttilAbout.jpg)"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Come with us and explore the culturally rich, talented and endlessly fascinating Palestine that continues to surprise and amaze everyone who looks a little deeper.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "the-map"
  }, [_c('div', {
    attrs: {
      "id": "chartdiv"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ecff08c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home/home.vue
// module id = 173
// module chunks = 5